import { newReducer } from 'utils/reducer';
import * as types from './UserManagement.types';

const initialState = {
  loading: false,
  loadingUpdate: false,
  loadingRepresentatives: false,
  loadingPowers: false,
  loadingResetPassword: false,
  loadingSetPassword: false,
  loadingPowerOperations: false,
  users: [],
  error: null,
  selectedUser: null,
  resetPasswordMessage: '',
  representatives: [],
  powers: [],
  searchResults: {
    entities: [],
    pagination: {
      total: 0,
      page: 0,
      limit: 10,
      totalPages: 0
    }
  },
  pagination: {
    page: 0,
    rowsPerPage: 10,
    total: 0,
  },
  filters: {
    searchTerm: '',
    userType: '',
    status: '',
  },
};

const userManagementReducer = newReducer(initialState, {
  // Fetch users with management details
  [types.USER_MANAGEMENT_FETCH_USERS]: (state) => {
    console.log('UserManagement Reducer: FETCH_USERS action received');
    return {
      ...state,
      loading: true,
      error: null,
    };
  },
  [types.USER_MANAGEMENT_FETCH_USERS_SUCCESS]: (state, action) => {
    console.log('UserManagement Reducer: FETCH_USERS_SUCCESS action received', action.payload);
    return {
      ...state,
      loading: false,
      users: action.payload.users || {},
      pagination: {
        ...state.pagination,
        ...action.payload.pagination
      },
      userOrder: action.payload.userOrder || [],
      error: null,
    };
  },
  [types.USER_MANAGEMENT_FETCH_USERS_ERROR]: (state, action) => {
    console.log('UserManagement Reducer: FETCH_USERS_ERROR action received', action.payload);
    return {
      ...state,
      loading: false,
      error: action.payload,
    };
  },

  // Fetch user details
  [types.USER_MANAGEMENT_FETCH_USER_DETAILS]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_FETCH_USER_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    selectedUser: action.payload,
    error: null,
  }),
  [types.USER_MANAGEMENT_FETCH_USER_DETAILS_ERROR]: (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }),

  // Reset password
  [types.USER_MANAGEMENT_RESET_PASSWORD]: (state) => ({
    ...state,
    loadingResetPassword: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_RESET_PASSWORD_SUCCESS]: (state, action) => ({
    ...state,
    loadingResetPassword: false,
    resetPasswordMessage: action.payload,
    error: null,
  }),
  [types.USER_MANAGEMENT_RESET_PASSWORD_ERROR]: (state, action) => ({
    ...state,
    loadingResetPassword: false,
    error: action.payload,
  }),

  // Set password
  [types.USER_MANAGEMENT_SET_PASSWORD]: (state) => ({
    ...state,
    loadingSetPassword: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_SET_PASSWORD_SUCCESS]: (state, action) => ({
    ...state,
    loadingSetPassword: false,
    error: null,
  }),
  [types.USER_MANAGEMENT_SET_PASSWORD_ERROR]: (state, action) => ({
    ...state,
    loadingSetPassword: false,
    error: action.payload,
  }),

  // Fetch user representatives
  [types.USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES]: (state) => ({
    ...state,
    loadingRepresentatives: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES_SUCCESS]: (state, action) => {
    console.log('=== REDUCER: FETCH_USER_REPRESENTATIVES_SUCCESS ===');
    console.log('Previous representatives:', state.representatives);
    console.log('New representatives payload:', action.payload);
    const newState = {
      ...state,
      loadingRepresentatives: false,
      representatives: action.payload,
      error: null,
    };
    console.log('New state representatives:', newState.representatives);
    return newState;
  },
  [types.USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES_ERROR]: (state, action) => ({
    ...state,
    loadingRepresentatives: false,
    error: action.payload,
  }),

  // Fetch user powers
  [types.USER_MANAGEMENT_FETCH_USER_POWERS]: (state) => ({
    ...state,
    loadingPowers: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_FETCH_USER_POWERS_SUCCESS]: (state, action) => ({
    ...state,
    loadingPowers: false,
    powers: action.payload,
    error: null,
  }),
  [types.USER_MANAGEMENT_FETCH_USER_POWERS_ERROR]: (state, action) => ({
    ...state,
    loadingPowers: false,
    error: action.payload,
  }),

  // Local state updates
  [types.USER_MANAGEMENT_SET_SEARCH]: (state, action) => ({
    ...state,
    filters: {
      ...state.filters,
      searchTerm: action.payload,
    },
  }),
  [types.USER_MANAGEMENT_SET_FILTERS]: (state, action) => ({
    ...state,
    filters: {
      ...state.filters,
      ...action.payload,
    },
  }),
  [types.USER_MANAGEMENT_SET_PAGINATION]: (state, action) => ({
    ...state,
    pagination: {
      ...state.pagination,
      ...action.payload,
    },
  }),

  // Legacy actions (keeping for future use)
  [types.USER_MANAGEMENT_CREATE_USER]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_CREATE_USER_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    users: {
      ...state.users,
      [action.payload.id]: action.payload
    },
    error: null,
  }),
  [types.USER_MANAGEMENT_CREATE_USER_ERROR]: (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }),
  [types.USER_MANAGEMENT_UPDATE_USER]: (state) => ({
    ...state,
    loadingUpdate: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_UPDATE_USER_SUCCESS]: (state, action) => ({
    ...state,
    loadingUpdate: false,
    users: {
      ...state.users,
      [action.payload.id]: action.payload
    },
    error: null,
  }),
  [types.USER_MANAGEMENT_UPDATE_USER_ERROR]: (state, action) => ({
    ...state,
    loadingUpdate: false,
    error: action.payload,
  }),
  [types.USER_MANAGEMENT_DELETE_USER]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_DELETE_USER_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    users: {
      ...state.users,
      [action.payload]: undefined, // Remove user from state
    },
    error: null,
  }),
  [types.USER_MANAGEMENT_DELETE_USER_ERROR]: (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }),

  // Update user representatives
  [types.USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    error: null,
  }),
  [types.USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES_ERROR]: (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }),

  // Search natural entities
  [types.USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    searchResults: {
      entities: action.payload.entities,
      pagination: action.payload.pagination
    },
    error: null,
  }),
  [types.USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES_ERROR]: (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }),

  // Create user power
  [types.USER_MANAGEMENT_CREATE_USER_POWER]: (state) => ({
    ...state,
    loadingPowerOperations: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_CREATE_USER_POWER_SUCCESS]: (state, action) => ({
    ...state,
    loadingPowerOperations: false,
    error: null,
  }),
  [types.USER_MANAGEMENT_CREATE_USER_POWER_ERROR]: (state, action) => ({
    ...state,
    loadingPowerOperations: false,
    error: action.payload,
  }),

  // Delete user power
  [types.USER_MANAGEMENT_DELETE_USER_POWER]: (state) => ({
    ...state,
    loadingPowerOperations: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_DELETE_USER_POWER_SUCCESS]: (state, action) => ({
    ...state,
    loadingPowerOperations: false,
    error: null,
  }),
  [types.USER_MANAGEMENT_DELETE_USER_POWER_ERROR]: (state, action) => ({
    ...state,
    loadingPowerOperations: false,
    error: action.payload,
  }),

  // Replace user power
  [types.USER_MANAGEMENT_REPLACE_USER_POWER]: (state) => ({
    ...state,
    loadingPowerOperations: true,
    error: null,
  }),
  [types.USER_MANAGEMENT_REPLACE_USER_POWER_SUCCESS]: (state, action) => ({
    ...state,
    loadingPowerOperations: false,
    error: null,
  }),
  [types.USER_MANAGEMENT_REPLACE_USER_POWER_ERROR]: (state, action) => ({
    ...state,
    loadingPowerOperations: false,
    error: action.payload,
  }),
});

export default userManagementReducer;